






import Vue from "vue";
import { Computed, Data, Method, Props } from "./types";
import { mapActions } from "vuex";
import { PostApplicationContractResponse } from "@/containers/applicationContract";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-stripe-billing-contract-application",
  props: {
    setupIntentId: { default: "" },
    clientSecret: { default: "" },
    paymentType: { default: "card" },
    waitingTime: { default: 0 },
    completeUrl: { default: "" },
    sendInvoiceUrl: { default: "" },
    errorUrl: { default: "" }
  },
  data() {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.initializeApplicationContract();
  },
  methods: {
    ...mapActions("applicationContract", ["postApplicationContract"]),
    async initializeApplicationContract() {
      try {
        const res: PostApplicationContractResponse = await this.postApplicationContract(
          {
            setupIntentId: this.setupIntentId,
            clientSecret: this.clientSecret,
            paymentType: this.paymentType
          }
        );

        this.isComplete = true;

        if (this.paymentType === "billing") {
          window.location.href = `${this.sendInvoiceUrl}?contractNumber=${res.contractNumber}`;
        } else {
          window.location.href = `${this.completeUrl}?contractNumber=${res.contractNumber}`;
        }
      } catch (error) {
        window.location.href = `${this.errorUrl}?type=${error.messageType}&errorCode=${error.errorCode}`;
      }
    }
  }
});
